<v2-row id="header-row" justifyContent="space-between" alignItems="center">
  <v2-header-secondary-text color="black">
    Pickup Time Full
  </v2-header-secondary-text>
  <v2-button
    color="transparent"
    (click)="bottomSheetRef.close()"
    *ngIf="areThereAnyTimeSlotSuggestions$ | async"
  >
    Cancel
  </v2-button>
</v2-row>

<v2-body-large-text
  class="description-text"
  color="black"
  *ngIf="areThereAnyTimeSlotSuggestions$ | async"
>
  Due to the high volume of orders, your selected pickup
  <b>({{ currentlySelectedDateTimeDisplayString$ | async }})</b> time is no
  longer available. Please consider these alternate pickup times.
</v2-body-large-text>

<v2-body-large-text
  class="description-text"
  color="black"
  *ngIf="!(areThereAnyTimeSlotSuggestions$ | async)"
>
  This location is closing soon, and does not have enough time to prepare your
  order. Please come again tomorrow.
</v2-body-large-text>

<div *ngIf="areThereAnyTimeSlotSuggestions$ | async">
  <v2-divider></v2-divider>
  <ng-container *ngFor="let suggestion of nonNullTimeSlotSuggestions$ | async">
    <v2-row
      class="suggestion"
      v2Ripple
      justifyContent="space-between"
      alignItems="center"
      (click)="bottomSheetRef.close(suggestion)"
    >
      <v2-row alignItems="center">
        <img
          src="assets/images/clock.svg"
          alt="clock icon"
          class="clock-icon"
        />
        <v2-body-header-heavy-text color="black">
          {{timeService.getReadableDateTime(suggestion, '')}}
        </v2-body-header-heavy-text>
      </v2-row>

      <v2-row alignItems="center">
        <v2-body-header-heavy-text color="primary">
          SELECT TIME
        </v2-body-header-heavy-text>
        <v2-icon
          icon="disclosure-right"
          color="primary"
          class="arrow-icon"
        ></v2-icon>
      </v2-row>
    </v2-row>
    <v2-divider></v2-divider>
  </ng-container>
</div>

<div *ngIf="!(areThereAnyTimeSlotSuggestions$ | async)">
  <v2-button id="close-button" color="primary" (click)="sendUserToScanPage()">
    CLOSE
  </v2-button>
</div>
